import { useState } from "react";
import { ReportAPI } from "../../../../axios/api";
import { useAbortedEffect } from "../../../../components/hooks";
import moment from "moment";

import ModuleSectionBlock from "../../../../components/sectionBlock";
import ModuleBlockLoading from "../../../../components/loading";
import { ModuleChartBar } from "../../../../components/chart";
import { floatAdd } from "../../../../service/common";
import { option_month } from "../../../../service/option";

export default function ModuleCustomChartMonthlyStatistic() {
  const [reload, setReload] = useState(true);
  const [apiData, setApiData] = useState({ keys: [], data: [] });

  useAbortedEffect(
    (signal) => {
      if (!reload) return;

      const thisYear = Number(moment().format("YYYY"));

      const params = {
        year: thisYear,
      };

      ReportAPI.getMonthlyYearComparison({
        options: { signal },
        data: params,
      }).then((result) => {
        let { Response, data } = result;

        if (Response === 1) {
          formatHandler({ data });
          setReload(false);
        }
      });
    },
    [reload]
  );

  const formatHandler = ({ data }) => {
    const itemsByMonth = new Map(
      data.items.map((item) => [Number(item.month), item]),
    );
    const totalEnergy = data.items.reduce(
      (total, item) =>
        floatAdd(
          total,
          floatAdd(Number(item.currentEnergy) || 0, Number(item.previousEnergy) || 0),
        ),
      0,
    );

    const formatData = option_month.map((month) => ({
      month: month.label,
      thisYear: itemsByMonth.get(Number(month.value))?.currentEnergy ?? 0,
      preYear: itemsByMonth.get(Number(month.value))?.previousEnergy ?? 0,
    }));

    setApiData({
      isTenThousandUnit: totalEnergy > 30000,
      keys: [
        { key: "thisYear", name: "今年月用量" },
        { key: "preYear", name: "去年月用量" },
      ],
      data: formatData,
    });
  };

  return (
    <ModuleSectionBlock
        targetId="monthlyStatistic"
        title="月用量"
        isExport={true}
        exportOptions={[
          {
            isList: true,
            listOptions: [
              {
                listColumns: [
                  {
                    field: "month",
                    header: "月份",
                    exportOptions: {
                      width: 12,
                    },
                  },
                  ...apiData.keys.map((item) => ({
                    field: item.key,
                    header: item.key,
                    exportOptions: {
                      width: 15,
                    },
                  })),
                ],
                listData: apiData.data,
                listPos: { x: 0, y: 1 },
              },
            ],
            isImg: true,
            imgOptions: [
              {
                imgId: "monthlyStatistic",
                imgPos: { x: 2 + apiData.keys.length, y: 1 },
              },
            ],
          },
        ]}
        bodyTemplate={
          <>
            {reload && <ModuleBlockLoading />}

            <ModuleChartBar
              isExpand={false}
              className="w-full h-15rem my-2"
              data={apiData}
              options={{
                dataKey: "month",
                yAxisOptions: {
                  label: {
                    left: {
                      value: `${apiData.isTenThousandUnit ? "萬" : ""}kWh`,
                      position: "insideTopLeft",
                      dx: apiData.isTenThousandUnit ? 30 : 40,
                      dy: -30,
                    },
                  },
                },
              }}
            />
          </>
        }
    />
  );
}
